/* eslint-disable react-hooks/exhaustive-deps */
import clsx from 'clsx'
import { FC, useContext, useEffect, useRef, useState } from 'react'
import { toAbsoluteUrl } from '../../../helpers'
import { HeaderUserMenu, ThemeModeSwitcher } from '../../../partials'
import { getAuth, JwtPayload } from '../../../../app/modules/auth'
import jwtDecode from 'jwt-decode'
import Select from 'react-select'
import { SelectOptionType } from '../../../../utils/MultiSelect'
import { currencies } from '../../../../utils/CurrencyList'
import { getSymbolOfCurrency } from '../../../../utils/CurrencyFormatter'
import { useUserNameStore } from '../../../../store/UserNameStore'
import { SwitchProduct } from './SwitchPlatform'
import { Icon } from '@iconify/react'
import { MenuComponent } from '../../../assets/ts/components/MenuComponent'
import Avatar from './Avatar'
import useIsMobile from '../../../../utils/detectDevice'
import { CurrencyDropdown } from './CurrencyDropdown'
import { AccountSwitcher } from './AccountSwitcher'
import { useGetPlatformInfo } from '../../../../app/modules/auth/core/_requests'
import { useAuthorizationStore } from '../../../../store/useAuthStore'
import { NotificationPopup } from './SSENotification'
import SyncDataIcon from '../../../../utils/SyncDataIcon'
import { MyChat } from '../../../../app/pages/openAI/chatWrapper'

const toolbarButtonMarginClass = 'ms-1 ms-lg-3',
  toolbarButtonHeightClass = 'w-30px h-30px w-md-40px h-md-40px',
  toolbarUserAvatarHeightClass = 'symbol-30px symbol-md-40px'

const Topbar: FC = () => {
  const auth = getAuth()!
  const jwt = jwtDecode<JwtPayload>(auth)
  const userNameStore = useUserNameStore()
  const { isMobile } = useIsMobile(1024)
  const userAuthStore = useAuthorizationStore()
  if (userNameStore.userName === '') userNameStore.setUserName(jwt.fullName!)
  const accessToken = sessionStorage.getItem('accessToken') || undefined
  const switchPlatformRef = useRef<any>(null)
  const profileRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    setTimeout(() => {
      MenuComponent.reinitialization()
    }, 50)
  }, [profileRef, accessToken])

  const currencyList: SelectOptionType[] = []
  currencies.forEach((currency: string) => {
    currencyList.push({
      value: currency,
      label: currency,
    })
  })

  const { data: userPlatformData } = useGetPlatformInfo(
    accessToken || '',
    accessToken !== undefined && accessToken !== ''
  )

  const [platformData, setPlatformData] = useState<any>(null)

  useEffect(() => {
    if (userPlatformData) {
      setPlatformData(userPlatformData)
    }
  }, [userPlatformData])

  const accessiblePlatforms = Array.from(
    new Set(
      platformData
        ?.filter((platform: any) => platform.data.access && platform.platform !== 'investor')
        .map((platform: any) => platform.platform)
    )
  )

  return (
    <div className='d-flex align-items-stretch flex-shrink-0 gap-4'>
      {/* <MyChat /> */}

      <div className='cursor-pointer d-flex align-items-center'>
        <AccountSwitcher />
      </div>

      <div className='d-flex align-items-center mt-4 justify-content-center h-50 ms-n3'>
        <CurrencyDropdown />
      </div>

      <div className='d-flex align-items-center mt-4 justify-content-center h-50 '>
        <SyncDataIcon tableId={''} isLoading={false} setFilterCondition={() => {}} />
      </div>

      <div className='d-flex align-items-center mt-4 justify-content-center h-50 '>
        <NotificationPopup />
      </div>

      <div
        className='d-none d-lg-flex align-items-center mt-4 justify-content-center h-50 border-end border-gray-300'
        aria-hidden='true'
      />
      {accessiblePlatforms.length > 0 ? (
        <div
          ref={switchPlatformRef}
          id='kt_header_switch_product_toggle'
          className={clsx(
            `cursor-pointer symbol d-flex align-items-center`,
            toolbarUserAvatarHeightClass
          )}
          data-kt-menu-trigger={isMobile ? 'click' : 'hover'}
          data-kt-menu-attach='parent'
          data-kt-menu-placement='bottom-end'
          data-kt-menu-flip='bottom'
        >
          <Icon
            icon='icon-park-outline:application-menu'
            className={`text-gray-700 text-hover-primary`}
            height={20}
            onMouseEnter={() => {
              setTimeout(() => {
                MenuComponent.reinitialization()
              }, 50)
            }}
          />
          <SwitchProduct data={platformData} />
        </div>
      ) : (
        <div
          className={clsx(
            `cursor-pointer symbol d-flex align-items-center`,
            toolbarUserAvatarHeightClass
          )}
        >
          <Icon
            icon='icon-park-outline:application-menu'
            className={`text-gray-300 `}
            height={20}
          />
        </div>
      )}

      <div
        className={clsx('d-flex align-items-center p-0', toolbarButtonMarginClass)}
        id='kt_header_user_menu_toggle'
      >
        <div
          ref={profileRef}
          className={clsx('cursor-pointer symbol', toolbarUserAvatarHeightClass)}
          data-kt-menu-trigger={isMobile ? 'click' : 'hover'}
          data-kt-menu-attach='parent'
          data-kt-menu-placement='bottom-end'
          data-kt-menu-flip='bottom'
        >
          <Avatar
            name={jwt.fullName || ''}
            profileImage={(platformData && platformData[0]?.profilePicUrl) || ''}
          />
        </div>
        <HeaderUserMenu
          userName={jwt.fullName!}
          userEmail={jwt.emailId!}
          profileImage={(platformData && platformData[0]?.profilePicUrl) || ''}
        />
      </div>
    </div>
  )
}

export { Topbar }
